import * as React from 'react'
import * as XStateReact from '@xstate/react'
import { useIntl } from 'react-intl'
import * as Auth from 'contexts/authentication'
import Schemas from 'clients/min/schemas'
import { Session as Storage } from 'services/storage'
import * as Root from '../machines/root'
import * as Resolver from '../resolver'

const Context = React.createContext()

export function Provider({ children, values, schemas }) {
    const machine = Root.useMachine(values, Store, schemas.data)
    const service = machine[2]
    const context = React.useMemo(() => ({ service, schemas }), [schemas, service])

    return <Context.Provider value={context}>{children}</Context.Provider>
}

export async function getSchemas(version, locale) {
    const [data, form, display] = await Promise.all([
        Schemas.getData(version, locale),
        Schemas.getForm(version, locale),
        Schemas.getDisplay(version, locale),
    ])

    return { data, form, display }
}

// Hooks
export function useService() {
    const service = useServiceObject()

    return XStateReact.useService(service)
}
export function useServiceObject() {
    const { service } = useContext()

    return service
}
export function useCurrentValues() {
    const { current } = useValues()

    return current
}
export function useUsername() {
    const { initial } = useValues()
    const authUsername = Auth.useUsername()
    const intl = useIntl()

    return (
        initial?.username ||
        authUsername ||
        intl.formatMessage({
            description: 'Mountain Information Network Form',
            defaultMessage: 'Your username',
        })
    )
}

// Schemas
export function useDataSchema() {
    const { data } = useSchemas()

    return data
}
export function useFormSchema() {
    const { form } = useSchemas()

    return form
}
export function useDisplaySchema() {
    const { display } = useSchemas()

    return display
}

// Utils Hooks
function useValues() {
    const [state] = useService()

    return state.context.values
}
function useSchemas() {
    const { schemas } = useContext()

    return schemas
}
function useContext() {
    return React.useContext(Context)
}

// Storage
const Store = {
    set(data) {
        Storage.set(DATA_STORAGE_KEY, data)
    },
    get() {
        return Storage.get(DATA_STORAGE_KEY)
    },
    clear() {
        Storage.remove(DATA_STORAGE_KEY)
    },
    has() {
        return Storage.has(DATA_STORAGE_KEY)
    },
}
const DATA_STORAGE_KEY = 'mountain-information-network-form-data'
